// 超过指定长度字符显示省略号
export var lengthLimit = function lengthLimit(field) {
  var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var isOmit = field.length <= num;
  return isOmit ? field : "".concat(field.substring(0, num), "...");
};